import API_Error from "@/errors/api_error";
import FE_Error from "@/errors/fe_error";
// import  ".env.local"

async function callAPI(
  url: string,
  body: unknown,
  method: "GET" | "POST" | "PUT" | "PATCH"
) {
  const userId = localStorage.getItem("userId") || "";
  const authtoken = localStorage.getItem("trends_user") || "";
  try {
    const response = await fetch(process.env.NEXT_PUBLIC_BASE_API_URL + url, {
      method,
      cache: "no-store",
      headers: new Headers({
        "Content-Type": "application/json",
        "X-USER-ID-TRENDS": userId,
        Authorization: `Bearer ${authtoken}`,
      }),
      body: method === "POST" ? JSON.stringify(body) : undefined,
    });
    if (!response.ok) {

      if(response.status === 401){
        localStorage.clear()
        window.dispatchEvent(new Event("user:refresh"));
      }
      if (response.status === 401 || response.status === 422) {
        return response.json();
      }
      return new API_Error(response);
    }
    const userIdentity = response.headers.get("x-user-id-trends");
    if (userIdentity) {
      localStorage.setItem("userId", userIdentity);
    }
    if (!response.status) {
      return new API_Error(response);
    }
    return response.json();
  } catch (e) {
    return new FE_Error(
      typeof e === "string"
        ? e
        : e instanceof Error
        ? e.message
        : JSON.stringify(e)
    );
  }
    
}

export function callGetApi(url: string) {
  return callAPI(url, {}, "GET");
}

export function callPostApi(url: string, body: unknown) {
  return callAPI(url, body, "POST");
}

export function callPutApi(url: string, body: unknown) {
  return callAPI(url, body, "PUT");
}

export function callPatchApi(url: string, body: unknown) {
  return callAPI(url, body, "PATCH");
}
